import axios from './axios'
import axiosRaw from 'axios'
import { API_CONFIG } from '../config/constants'
import { generateAuthHeaders } from '../utils/auth'

export const checkToken = (userData) => {
    return axios.request({
        url: `${API_CONFIG.BASE_URL}/v2/user/token/verify`,
        method: 'post',
        data: {
            username: userData.username,
            password: userData.password,
        },
    })
}

export const phonePasswordLogin = (credentials) => {
    const path = '/api/v1/auth/phone_password_login'
    const headers = generateAuthHeaders('POST', path)
    return axiosRaw.post('https://server.love-study.tech' + path, {
        phone: credentials.phone,
        password: credentials.password,
    }, { headers })
}

export const generateAccount = (validityPeriod) => {
    return axios.request({
        url: '/v1/auth/generate_account',
        method: 'post',
        data: {
            validity_period: validityPeriod,
        },
    })
}
